import { replace } from "connected-react-router";
import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/AcceptInvite";

export function* acceptInvite(action: Actions.AcceptInviteAction) {
    const { payload } = action;
    const { credentials, inviteId, redirectOnSuccess } = payload;

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });
        yield put(loading(true, action));
        yield api.acceptInvite(inviteId);
        if (redirectOnSuccess) {
            yield put(replace(redirectOnSuccess));
        }
        yield put(Actions.acceptInviteEnd(undefined));
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield put(Actions.acceptInviteEnd(e));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchAcceptInvite() {
    yield takeEvery(Actions.ACCEPT_INVITE, acceptInvite);
}
